import config, { isHomologationEnvironment } from "../config/default";

/**
 * Hash route that the gateway redirects back to after Microsoft authentication.
 * The gateway sets the accessToken/refreshToken cookies on the shared parent
 * domain before issuing this redirect, so the landing only needs to resolve the
 * final destination.
 */
export const MICROSOFT_CALLBACK_ROUTE = "/microsoft-callback";

/**
 * Resolves the Atem Gateway base URL for the current environment, mirroring
 * AxiosHttpService.getBaseUrl().
 */
export function getGatewayBaseUrl(): string {
  return isHomologationEnvironment(window.location.hostname)
    ? config.api.url.homologation
    : config.api.url.production;
}

/**
 * Builds the frontend landing URL (return_to) that the gateway will redirect to
 * after Microsoft login. The original `url` / `rules` are round-tripped so the
 * landing knows where to forward the user next (same contract as the password
 * flow). Uses the HashRouter format: `<origin>/#/microsoft-callback?...`.
 */
export function buildReturnTo(params: { url?: string; rules?: string }): string {
  const { origin } = window.location;
  const search = new URLSearchParams();
  if (params.url) search.set("url", params.url);
  if (params.rules) search.set("rules", params.rules);
  const query = search.toString();
  return `${origin}/#${MICROSOFT_CALLBACK_ROUTE}${query ? `?${query}` : ""}`;
}

/**
 * Navigates the browser to the gateway's Microsoft authorize endpoint to start
 * the corporate ("Login Corporativo") login flow.
 */
export function startMicrosoftLogin(params: { url?: string; rules?: string }): void {
  const gateway = getGatewayBaseUrl();
  const returnTo = buildReturnTo(params);
  window.location.href = `${gateway}/auth/microsoft/authorize?return_to=${encodeURIComponent(returnTo)}`;
}
